export default "__VITE_ASSET__DGOA_TEC__"